import { Injectable } from '@angular/core';
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class CustomDateFormatter extends NgbDateParserFormatter {

  parse(value: string): NgbDateStruct | null {
    if (value) {
      const parts = value.trim().split('/');
      if (parts.length === 3) {
        return { day: +parts[0], month: +parts[1], year: +parts[2] };
      }
    }
    return null;
  }

  format(date: NgbDateStruct | null): string {
    return date ? `${date.day}/${date.month}/${date.year}` : '';
  }
}
